$(document).ready(function() {
  
  // Account page seal-sub magic link
  $("#seal-magic-link").submit(function(e) {
      e.preventDefault();

      var form = $(this);
      var url = form.attr('action');
    
      send_email = encodeURIComponent("customer_email=" + $('#Send-Email').val());

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize() + "&send_email=" + send_email,
        success: function(data)
        {
          if (data.success == true) {
            form.after("<p>We have received your request and will send you an email in the next minute if there is at least one subscription linked to your email. Thank you!</p>");
            form.prev().hide();
            form.hide();
          }
        }
      });
  });

});